import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Container,
  Grid,
  Input,
  Typography,
} from '@mui/joy'
import Avatar from '@mui/joy/Avatar'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import ListItemContent from '@mui/joy/ListItemContent'
import React from 'react'

type CardSettingProps = {
  numberOfStamps: number
}

function CardSettings(props: CardSettingProps) {
  return (
    <Accordion>
      <AccordionSummary>
        <Avatar color="primary">
          <LoyaltyIcon />
        </Avatar>
        <ListItemContent>
          <Typography level="title-md">Kártya</Typography>
          <Typography level="body-sm">Kártya beállítások</Typography>
        </ListItemContent>
      </AccordionSummary>
      <AccordionDetails>
        <Container maxWidth="xs" sx={{ pt: 2 }}>
          <Card>
            <Container maxWidth="xs">
              <Grid container spacing={1}>
                <Grid xs={5} md={6} lg={5}>
                  <Input
                    disabled
                    type="number"
                    value={props.numberOfStamps}
                    slotProps={{
                      input: {
                        min: 1,
                        max: 20,
                        defaultValue: 9,
                      },
                    }}
                  />
                </Grid>
                <Grid xs={7} md={6} lg={7}>
                  <Typography level="body-sm" sx={{ pt: 0.7 }}>
                    db bélyeg
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </Card>
        </Container>
      </AccordionDetails>
    </Accordion>
  )
}

export default CardSettings
